import * as React from 'react';
import Chip from '@mui/material/Chip';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

export default function Tags(props) {

  const handleSelectTags = (event, selectedValues) => {
    props.selectedTags(selectedValues);    
  };


  return (<>
    <Autocomplete 
      size='small'
      multiple
      limitTags={(window.innerWidth>600)?7:2}
      id="tags-filled"
      onChange={handleSelectTags}
      options={(props.options && props.options.length>0)?props.options.map((option) => option.title):null}
      defaultValue={props.defaultValues}
      freeSolo={props.freeSolo}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => (
          <Chip variant="outlined" size="small" label={option} {...getTagProps({ index })} />
        ))
      }
      renderInput={(params) => (
        <TextField
          {...params}                        
          label={props.label}
          placeholder={props.placeholder}            
        />
      )}
    />
</>);
}
///const optionsarr = [{ title: 'abc'},{ title: 'xyz'},{ title: 'mno'}];